<template>
  <div class="input">
    <div class="input-label">開始時間</div>
    <div class="input-group">
      <input
        type="number"
        min="0"
        max="23"
        class="input-text"
        v-model="startHour"
        disabled
        >

      <div class="input-label_after">時</div>

      <input
        type="number"
        min="0"
        max="59"
        class="input-text"
        v-model="startMinute"
        disabled
        >

      <div class="input-label_after">分</div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    startHour: {
      get: function () {
        return this.$store.state.eventClosed.startHour
      },
      set: function (value) {
        this.$store.commit(
          'eventClosed/setStartHour',
          value
        )
      }
    },

    startMinute: {
      get: function () {
        return this.$store.state.eventClosed.startMinute
      },
      set: function (value) {
        this.$store.commit(
          'eventClosed/setStartMinute',
          value
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss';
</style>
